import React, { useRef, useEffect, useState, Fragment, memo } from 'react';
import PropTypes from 'prop-types';
import { stringify } from 'qs';
import LazyLoad from 'react-lazyload';

var propTypes = {
  className: PropTypes.string,
  item: PropTypes.shape({
    buyNowPrice: PropTypes.number,
    currentBid: PropTypes.number,
    discountRate: PropTypes.number,
    displayHighlighted: PropTypes.bool,
    existsInWishList: PropTypes.bool,
    hasDiscount: PropTypes.bool,
    hasNonSpecifiedShipping: PropTypes.bool,
    imageUrl: PropTypes.string,
    isEndingSoon: PropTypes.bool,
    isNewToday: PropTypes.bool,
    isShopItem: PropTypes.bool,
    itemId: PropTypes.number,
    itemUrl: PropTypes.string,
    prettifyRating: PropTypes.shape({
      includeTotal: PropTypes.bool,
      isBad: PropTypes.bool,
      isGood: PropTypes.bool,
      noRating: PropTypes.bool,
      rating: PropTypes.string
    }),
    price: PropTypes.number,
    priceBeforeDiscount: PropTypes.number,
    sellerAlias: PropTypes.string,
    sellerDsrAverage: PropTypes.number,
    shortDescription: PropTypes.string,
    showBids: PropTypes.bool,
    showBuyNow: PropTypes.bool,
    showFreeShippingRibbon: PropTypes.bool,
    showOnDisplayRibbon: PropTypes.bool,
    showShopItemSettings: PropTypes.bool,
    showSmbMessage: PropTypes.bool,
    timeLeft: PropTypes.string,
    url: PropTypes.string
  }),
  itm: PropTypes.shape({
    medium: PropTypes.string,
    source: PropTypes.string
  }),
  lazy: PropTypes.shape({
    offset: PropTypes.number,
    once: PropTypes.bool,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    placeholder: PropTypes.node,
    imagePlaceholder: PropTypes.node
  }),
  text: PropTypes.shape({
    buyNow: PropTypes.string.isRequired,
    fixedPrice: PropTypes.string.isRequired,
    newToday: PropTypes.string.isRequired,
    notRated: PropTypes.string.isRequired,
    numberOfBidsWithCount: PropTypes.func.isRequired,
    onDisplay: PropTypes.string.isRequired,
    rating: PropTypes.string.isRequired,
    savedToWishlist: PropTypes.string.isRequired,
    saveToWishlist: PropTypes.string.isRequired,
    shipping: PropTypes.shape({
      freeShipping: PropTypes.string.isRequired,
      nonSpecifiedShipping: PropTypes.string.isRequired,
      pickupOnly: PropTypes.string.isRequired,
      addedShippingCost: PropTypes.func.isRequired
    })
  }),
  onAddToWishlist: PropTypes.func,
  onRemoveFromWishlist: PropTypes.func,
  onQuickView: PropTypes.func,
  onSettings: PropTypes.func,
  ready: PropTypes.bool
};
var defaultProps = {
  className: "",
  onAddToWishlist: function onAddToWishlist() {},
  onRemoveFromWishlist: function onRemoveFromWishlist() {},
  onQuickView: function onQuickView() {},
  text: {
    buyNow: "Köp nu",
    ended: "Avslutad",
    fixedPrice: "Fast pris",
    freeShipping: "Fri frakt!",
    newToday: "Ny idag",
    notRated: "Ej bedömd",
    numberOfBidsWithCount: function numberOfBidsWithCount(count) {
      return "".concat(count, " bud");
    },
    onDisplay: "Utvald!",
    pickup: "Avhämtning",
    rating: "Betyg:",
    savedToWishlist: "Sparad i minneslistan",
    saveToWishlist: "Spara i minneslistan",
    shipping: {
      freeShipping: "Fri frakt",
      nonSpecifiedShipping: "Ospec. frakt",
      pickupOnly: "Upphämtning",
      addedShippingCost: function addedShippingCost(shippingPrice) {
        return "+".concat(shippingPrice, " frakt");
      }
    },
    unspecifiedShippingShort: "Ospec. frakt"
  }
};

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var parseItmObject = function parseItmObject(itm) {
  return Object.assign.apply(Object, [{}].concat(_toConsumableArray(Object.keys(itm).map(function (key) {
    return _defineProperty({}, "itm_".concat(key), itm[key]);
  }))));
};
/**
 * Converts an itm object to query string
 * @param {Object} itm - Object containing the itm properties
 * @param {string} itm.source - Reference to the referring location/page e.g: 'vip'
 * @param {string} itm.medium - Reference to the unique element e.g 'suggest-from-blueshift'
 */


var itmToQueryString = function itmToQueryString(itm) {
  return !itm ? '' : "?".concat(stringify(parseItmObject(itm)));
};

function formatNumberWithSeparators(number) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "\u2006";
  return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + separator);
} // https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString


function toLocaleStringSupportsLocales() {
  try {
    Number(0).toLocaleString("i");
  } catch (e) {
    return e.name === "RangeError";
  }

  return false;
} // https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString


function toLocaleStringSupportsOptions() {
  return !!((typeof Intl === "undefined" ? "undefined" : _typeof(Intl)) === "object" && Intl && typeof Intl.NumberFormat === "function");
}

var isLocaleFormattingSupportedInBrowser = toLocaleStringSupportsLocales() && toLocaleStringSupportsOptions();

function formatPrice(price) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "sv-SE";
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!isLocaleFormattingSupportedInBrowser) {
    return "".concat(typeof price === "number" ? price : parseInt(price), " ").concat(locale.startsWith("sv") ? "kr" : "SEK");
  }

  var formattedPrice = typeof price !== "number" ? parseInt(price) : price;

  var opts = _objectSpread2({
    style: "currency",
    currency: "SEK",
    currencyDisplay: "symbol",
    useGrouping: false,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }, options);

  formattedPrice = formattedPrice.toLocaleString(locale, opts);
  formattedPrice = formatNumberWithSeparators(formattedPrice);
  return formattedPrice;
}

var MultiCurrency = function MultiCurrency(props) {
  var amountInSek = props.amountInSek,
      className = props.className,
      language = props.language,
      preferredCurrency = props.preferredCurrency,
      TagName = props.tagName;

  if (!preferredCurrency || preferredCurrency.code === "SEK") {
    return null;
  }

  var amountInOtherCurrency = amountInSek * preferredCurrency.rate;

  if (amountInOtherCurrency <= 0) {
    return null;
  }

  var formattedPrice = formatPrice(amountInOtherCurrency, language, {
    currency: preferredCurrency.code,
    maximumFractionDigits: preferredCurrency.decimals
  });
  return React.createElement(TagName, {
    className: "notranslate ".concat(className)
  }, "\u2248\xA0", formattedPrice);
};

MultiCurrency.propTypes = {
  amountInSek: PropTypes.number.isRequired,
  className: PropTypes.string,
  language: PropTypes.string,
  preferredCurrency: PropTypes.shape({
    // Rate in perce
    rate: PropTypes.number.isRequired,
    decimals: PropTypes.number.isRequired,
    code: PropTypes.string.isRequired,
    symbolPrefix: PropTypes.string,
    symbolSuffix: PropTypes.string
  }),
  tagName: PropTypes.string
};
MultiCurrency.defaultProps = {
  language: "sv-SE",
  tagName: "span"
};

function _typeof$1(obj) {
  if (typeof Symbol === "function" && _typeof(Symbol.iterator) === "symbol") {
    _typeof$1 = function _typeof$1(obj) {
      return _typeof(obj);
    };
  } else {
    _typeof$1 = function _typeof$1(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof(obj);
    };
  }

  return _typeof$1(obj);
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(source, true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function formatDuration(durationInSeconds) {
  var minuteBreakpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60;

  if (Number.isInteger(durationInSeconds)) {
    return durationInSeconds > minuteBreakpoint ? "".concat(Math.floor(durationInSeconds / 60), "m") : "".concat(durationInSeconds, "s");
  } else {
    return "";
  }
}

function formatNumberWithSeparators$1(number) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "\u2006";
  return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + separator);
} // https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString


function toLocaleStringSupportsLocales$1() {
  try {
    Number(0).toLocaleString("i");
  } catch (e) {
    return e.name === "RangeError";
  }

  return false;
} // https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString


function toLocaleStringSupportsOptions$1() {
  return !!((typeof Intl === "undefined" ? "undefined" : _typeof$1(Intl)) === "object" && Intl && typeof Intl.NumberFormat === "function");
}

var isLocaleFormattingSupportedInBrowser$1 = toLocaleStringSupportsLocales$1() && toLocaleStringSupportsOptions$1();

function formatPrice$1(price) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "sv-SE";
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!isLocaleFormattingSupportedInBrowser$1) {
    return "".concat(typeof price === "number" ? price : parseInt(price), " ").concat(locale.startsWith("sv") ? "kr" : "SEK");
  }

  var formattedPrice = typeof price !== "number" ? parseInt(price) : price;

  var opts = _objectSpread2$1({
    style: "currency",
    currency: "SEK",
    currencyDisplay: "symbol",
    useGrouping: false,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }, options);

  formattedPrice = formattedPrice.toLocaleString(locale, opts);
  formattedPrice = formatNumberWithSeparators$1(formattedPrice);
  return formattedPrice;
}

var useDidMountEffect = function useDidMountEffect(func, deps) {
  var didMount = useRef(false);
  useEffect(function () {
    if (didMount.current) func();else didMount.current = true;
  }, deps);
};
/**
 * Loads an image source and keep track of isLoaded and error states.
 *
 * @param {string} src
 * @returns {[boolean, boolean]}
 */


function useImageLoader(src) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoaded = _useState2[0],
      setIsLoaded = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  useEffect(function () {
    var image = new Image();

    image.onload = function () {
      return setIsLoaded(true);
    };

    image.onerror = function () {
      return setError(true);
    };

    image.src = src;
    return function () {
      image.onload = null;
      image.onerror = null;
    };
  }, [src]);
  return [isLoaded, error];
}

var intervals = {};
/**
 * Set up an periodical call to a component callback.
 * Intervals with the same period time are reused.
 * The interval can be cancelled with the returned function. It also cancels itself when no component uses it.
 *
 * @param {int} period - Milliseconds
 * @param {function} callback
 * @returns {function}
 */

function useTicker(period, callback) {
  // Remove callback from interval and cancel interval if no callbacks remain
  var cleanup = function cleanup() {
    if (intervals[period]) {
      intervals[period].callbacks = intervals[period].callbacks.filter(function (cb) {
        return cb !== callback;
      });

      if (intervals[period].callbacks.length === 0) {
        clearInterval(intervals[period].intervalId);
        intervals[period] = undefined;
      }
    }
  };

  useEffect(function () {
    // Reuse existing interval
    if (intervals[period]) {
      intervals[period].callbacks.push(callback); // Add callback to new interval and save interval id for cancellation
    } else {
      var intervalId = setInterval(function () {
        intervals[period].callbacks.forEach(function (cb) {
          return cb();
        });
      }, period);
      intervals[period] = {
        callbacks: [callback],
        intervalId: intervalId
      };
    } // Return cancellation callback


    return cleanup;
  });
  return cleanup;
}

var ImageLoader = function ImageLoader(props) {
  var src = props.src,
      placeholder = props.placeholder,
      fallback = props.fallback,
      otherProps = _objectWithoutProperties(props, ["src", "placeholder", "fallback"]);

  var _useImageLoader = useImageLoader(src),
      _useImageLoader2 = _slicedToArray(_useImageLoader, 2),
      isLoaded = _useImageLoader2[0],
      error = _useImageLoader2[1];

  if (isLoaded) {
    return React.createElement("img", _extends({
      src: src
    }, otherProps));
  } else if (error) {
    return fallback;
  } else {
    return placeholder;
  }
};

ImageLoader.propTypes = {
  src: PropTypes.string.isRequired,
  placeholder: PropTypes.element.isRequired,
  fallback: PropTypes.element
};

var BackgroundImageLoader = function BackgroundImageLoader(props) {
  var TagName = props.tagName,
      className = props.className,
      style = props.style,
      src = props.src,
      placeholderSrc = props.placeholderSrc,
      placeholderClassName = props.placeholderClassName,
      fallbackSrc = props.fallbackSrc,
      fallbackClassName = props.fallbackClassName,
      loadedClassName = props.loadedClassName,
      children = props.children,
      otherProps = _objectWithoutProperties(props, ["tagName", "className", "style", "src", "placeholderSrc", "placeholderClassName", "fallbackSrc", "fallbackClassName", "loadedClassName", "children"]);

  var _useImageLoader3 = useImageLoader(src),
      _useImageLoader4 = _slicedToArray(_useImageLoader3, 2),
      isLoaded = _useImageLoader4[0],
      error = _useImageLoader4[1];

  var currentSrc = placeholderSrc;
  var currentClassName = className + " " + placeholderClassName;

  if (isLoaded) {
    currentSrc = src;
    currentClassName = className + " " + loadedClassName;
  } else if (error) {
    currentSrc = fallbackSrc;
    currentClassName = className + " " + fallbackClassName;
  }

  return React.createElement(TagName, _extends({}, otherProps, {
    className: currentClassName,
    style: _objectSpread2({}, style, {
      backgroundImage: currentSrc ? "url(".concat(currentSrc, ")") : ""
    })
  }), children);
};

BackgroundImageLoader.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  src: PropTypes.string,
  placeholderSrc: PropTypes.string,
  placeholderClassName: PropTypes.string,
  fallbackSrc: PropTypes.string,
  fallbackClassName: PropTypes.string,
  loadedClassName: PropTypes.string
};
BackgroundImageLoader.defaultProps = {
  tagName: "div"
};

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.4 7.2C2.7 5.9 5.3 4 8 4s5.3 1.9 6.7 3.2c.5.5.5 1.2 0 1.6C13.3 10.1 10.8 12 8 12c-2.7 0-5.3-1.9-6.6-3.2-.5-.4-.5-1.1 0-1.6zM8 3C4.8 3 2.1 5.1.7 6.5c-.9.8-.9 2.2 0 3C2.1 10.9 4.8 13 8 13s5.9-2.1 7.3-3.5c.9-.8.9-2.2 0-3C13.9 5.1 11.1 3 8 3zM6.9 8c0-.6.5-1.1 1.1-1.1s1.1.5 1.1 1.1S8.6 9.1 8 9.1 6.9 8.6 6.9 8zM8 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
});

var SvgQuicklook = function SvgQuicklook(props) {
  return React.createElement("svg", _extends$1({
    viewBox: "0 0 16 16"
  }, props), _ref);
};

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

var _ref$1 =
/*#__PURE__*/
React.createElement("path", {
  className: "quicklook_fill_svg__st0",
  d: "M8 3C4.8 3 2.1 5.1.7 6.5c-.9.8-.9 2.2 0 3C2.1 10.9 4.8 13 8 13s5.9-2.1 7.3-3.5c.9-.8.9-2.2 0-3C13.9 5.1 11.2 3 8 3zm0 3c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

var SvgQuicklookFill = function SvgQuicklookFill(props) {
  return React.createElement("svg", _extends$2({
    viewBox: "0 0 16 16"
  }, props), _ref$1);
};

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

var _ref$2 =
/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M8 2.5C7.1 1.2 5.4.8 4 1.1 2.1 1.5.5 3 .5 5.6c0 2.7 2 6 7.2 9.3.2.1.4.1.5 0 5.3-3.3 7.2-6.6 7.2-9.3 0-2.6-1.6-4.2-3.5-4.5-1.3-.3-3 .1-3.9 1.4zm-3.8-.4c-1.4.3-2.7 1.4-2.7 3.5s1.6 5.1 6.5 8.3c4.9-3.2 6.5-6.2 6.5-8.3S13.2 2.3 11.8 2s-2.9.3-3.4 1.6c0 .3-.2.4-.4.4s-.4-.1-.5-.3c-.4-1.3-1.9-1.9-3.3-1.6z",
  fillRule: "evenodd"
});

var SvgHeart = function SvgHeart(props) {
  return React.createElement("svg", _extends$3({
    viewBox: "0 0 16 16"
  }, props), _ref$2);
};

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

var _ref$3 =
/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M15.5 5.6c0-2.6-1.6-4.2-3.5-4.5-1.5-.3-3.1.2-4 1.4C7.1 1.2 5.4.8 4 1.1 2.1 1.5.5 3 .5 5.6c0 2.7 2 6 7.2 9.3.2.1.4.1.5 0 5.3-3.3 7.3-6.6 7.3-9.3z",
  fillRule: "evenodd"
});

var SvgHeartFill = function SvgHeartFill(props) {
  return React.createElement("svg", _extends$4({
    viewBox: "0 0 16 16"
  }, props), _ref$3);
};

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

var _ref$4 =
/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M4.6 3.7c.5.1 1-.2 1.2-.7l.5-1.2c.1-.5.4-.8.9-.8h1.4c.4 0 .8.3 1 .7L10 3c.1.5.7.8 1.2.7l1.6-.4c.4-.1.9.1 1.1.5l.7 1.2c.2.4.2.9-.1 1.2l-1.2 1.2c-.4.4-.4 1 0 1.4l1.2 1.2c.3.3.4.8.1 1.2l-.6 1.1c-.2.4-.7.6-1.1.5l-1.6-.4c-.6-.2-1.2.1-1.3.6l-.5 1.2c-.1.5-.5.8-.9.8H7.2c-.4 0-.8-.3-1-.7l-.5-1.2c-.1-.5-.7-.8-1.2-.7l-1.6.4c-.4.1-.9-.1-1.1-.5l-.7-1.2c-.2-.4-.1-.9.2-1.2l1.2-1.2c.4-.4.4-1 0-1.4L1.3 6.1c-.3-.3-.4-.8-.2-1.2l.7-1.2c.2-.4.7-.6 1.1-.5zm.1.8l-1.1-.2c-.3-.1-.6-.2-.9-.2l-.8 1.3c.4.4.6.7.8.9l1 1.2c.3.3.3.8 0 1.1l-1 1.1c-.1.2-.4.5-.8.9l.7 1.3c.4-.1.7-.1 1-.2l1.4-.3c.5-.1 1.3.4 1.5.8l.4 1.2c-.1.2 0 .4.1.6h1.7c.2-.2.3-.4.3-.6l.5-1.3c.1-.4.9-.8 1.3-.7l1.5.3c.3.1.6.1.9.2l.8-1.2c-.2-.3-.4-.5-.6-.7l-1.1-1.2c-.3-.3-.4-1.4-.1-1.7L13.3 6l.6-.6-.8-1.3c-.3 0-.6.1-.8.1l-1.3.3c-.4.1-1.5-.2-1.6-.6L9 3c-.1-.3-.2-.6-.4-1H7.1c-.1.3-.2.5-.3.7l-.5 1.1c-.1.5-1.1.8-1.6.7zM8 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm0-1c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1z",
  fillRule: "evenodd"
});

var SvgSettings = function SvgSettings(props) {
  return React.createElement("svg", _extends$5({
    viewBox: "0 0 16 16"
  }, props), _ref$4);
};

var AnimatedPriceLabel = function AnimatedPriceLabel(props) {
  var price = props.price,
      language = props.language;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showAnimation = _useState2[0],
      setShowAnimation = _useState2[1];

  useDidMountEffect(function () {
    setShowAnimation(true);
    var timer = setTimeout(function () {
      setShowAnimation(false);
    }, 500);
    return function () {
      return clearTimeout(timer);
    };
  }, [price]);

  var priceLabelProps = _objectSpread2({}, props, {
    className: "".concat(props.className).concat(showAnimation ? " item-card-details-price-highlight" : "")
  });

  return React.createElement(PriceLabel, priceLabelProps);
};

AnimatedPriceLabel.propTypes = {
  tagName: PropTypes.string,
  className: PropTypes.string,
  price: PropTypes.number,
  hasDiscount: PropTypes.bool,
  language: PropTypes.string
};
AnimatedPriceLabel.defaultProps = {
  tagName: "span",
  className: ""
};

var AnimatedTimeLeftLabel = function AnimatedTimeLeftLabel(_ref) {
  var className = _ref.className,
      countdownSecondsLimit = _ref.countdownSecondsLimit,
      countdownWarningLimit = _ref.countdownWarningLimit,
      endedComponent = _ref.endedComponent,
      TagName = _ref.tagName,
      endDate = _ref.endDate;
  var timeLeftSeconds = Math.floor((new Date(endDate) - new Date()) / 1000);

  var _useState3 = useState(timeLeftSeconds),
      _useState4 = _slicedToArray(_useState3, 2),
      countdown = _useState4[0],
      setCountdown = _useState4[1];

  var stopCountdown = useTicker(1000, function () {
    if (countdown > 0) {
      setCountdown(countdown - 1);
    } else {
      stopCountdown();
    }
  });

  if (countdown === 0) {
    return endedComponent;
  }

  return React.createElement(TagName, {
    className: "item-card-animate-time ".concat(className)
  }, React.createElement("span", {
    className: "".concat(countdown <= countdownWarningLimit ? "text-danger" : "")
  }, formatDuration(countdown, countdownSecondsLimit)), countdown <= countdownSecondsLimit && React.createElement(Fragment, null, "\xA0", React.createElement("svg", {
    viewBox: "0 0 40 40",
    className: "item-card-animate-time-left ".concat(countdown <= countdownWarningLimit ? "item-card-animate-time-left-soon" : "", " align-text-bottom")
  }, React.createElement("circle", {
    r: "19",
    cx: "20",
    cy: "20",
    className: "item-card-animate-time-left-outer"
  }), React.createElement("circle", {
    r: "9",
    cx: "20",
    cy: "20",
    className: "item-card-animate-time-left-inner",
    style: {
      strokeDasharray: "".concat(56 * countdown / countdownSecondsLimit, " 100")
    }
  }))));
};

AnimatedTimeLeftLabel.propTypes = {
  className: PropTypes.string,
  countdownSecondsLimit: PropTypes.number,
  countdownWarningLimit: PropTypes.number,
  endedComponent: PropTypes.node,
  tagName: PropTypes.string,
  endDate: PropTypes.object
};
AnimatedTimeLeftLabel.defaultProps = {
  className: "",
  // Show detailed countdown at this number of seconds left
  countdownSecondsLimit: 120,
  // Show warning countdown at this number of seconds
  countdownWarningLimit: 60,
  tagName: "span"
};

var BidsLabel = function BidsLabel(_ref2) {
  var className = _ref2.className,
      TagName = _ref2.tagName,
      text = _ref2.text;
  return React.createElement(TagName, {
    className: className
  }, text);
};

BidsLabel.defaultProps = {
  tagName: "span"
};

var BuyNowLabel = function BuyNowLabel(_ref3) {
  var className = _ref3.className,
      TagName = _ref3.tagName,
      text = _ref3.text;
  return React.createElement(TagName, {
    className: "badge badge-branded badge-inline text-nowrap ".concat(className || "")
  }, text);
};

BuyNowLabel.defaultProps = {
  tagName: "span"
};

var DiscountBadge = function DiscountBadge(_ref4) {
  var className = _ref4.className,
      discountRate = _ref4.discountRate;
  return React.createElement("span", {
    className: "badge badge-danger badge-inline ".concat(className || ""),
    "data-item-card-discount-rate": ""
  }, "-", discountRate, "%");
};

var DiscountedPriceLabel = function DiscountedPriceLabel(_ref5) {
  var className = _ref5.className,
      price = _ref5.price,
      TagName = _ref5.tagName;
  return React.createElement(TagName, {
    className: "text-secondary ".concat(className || "")
  }, formatNumberWithSeparators$1(price));
};

DiscountedPriceLabel.defaultProps = {
  tagName: "span"
};

var FixedPriceLabel = function FixedPriceLabel(_ref6) {
  var className = _ref6.className,
      text = _ref6.text;
  return React.createElement("span", {
    className: className
  }, text);
};

var ItemCardImage = function ItemCardImage(_ref7) {
  var className = _ref7.className,
      lazy = _ref7.lazy,
      itemUrl = _ref7.itemUrl,
      imageUrl = _ref7.imageUrl,
      shortDescription = _ref7.shortDescription,
      onClick = _ref7.onClick,
      children = _ref7.children;
  var linkProps = {
    href: itemUrl,
    className: "item-card-image ".concat(lazy ? "" : "item-card-image-loaded", " ").concat(className || ""),
    title: shortDescription,
    onClick: onClick,
    "data-item-card-image": ""
  };

  if (lazy) {
    return React.createElement(LazyLoad, lazy, React.createElement(BackgroundImageLoader, _extends({
      tagName: "a",
      src: imageUrl,
      placeholderClassName: "animation-loading-shimmer",
      loadedClassName: "item-card-image-loaded"
    }, linkProps), children));
  } else {
    return React.createElement("a", _extends({}, linkProps, {
      style: {
        backgroundImage: "url(".concat(imageUrl, ")")
      }
    }), children);
  }
};

var NewTodayLabel = function NewTodayLabel(_ref8) {
  var className = _ref8.className,
      text = _ref8.text;
  return React.createElement("span", {
    className: "text-danger ".concat(className || "")
  }, text);
};

var OnDisplayBadge = function OnDisplayBadge(_ref9) {
  var className = _ref9.className,
      text = _ref9.text;
  return React.createElement("span", {
    className: "badge badge-primary badge-inline text-nowrap ".concat(className || "")
  }, text.onDisplay);
};

var PriceLabel = function PriceLabel(_ref10) {
  var TagName = _ref10.tagName,
      className = _ref10.className,
      price = _ref10.price,
      hasDiscount = _ref10.hasDiscount,
      language = _ref10.language;

  if (price) {
    return React.createElement(TagName, {
      className: "".concat(hasDiscount ? "text-danger" : "", " ").concat(className)
    }, formatPrice$1(price, language, {
      // Swedish locale shows "kr", other "SEK"
      currencyDisplay: language.startsWith("sv") ? "symbol" : "code"
    }));
  } else {
    return null;
  }
};

PriceLabel.propTypes = {
  tagName: PropTypes.string,
  className: PropTypes.string,
  price: PropTypes.number,
  hasDiscount: PropTypes.bool,
  language: PropTypes.string
};
PriceLabel.defaultProps = {
  tagName: "span",
  className: "",
  language: "sv"
};

var QuickViewButton = function QuickViewButton(_ref11) {
  var className = _ref11.className,
      iconClassName = _ref11.iconClassName,
      onClick = _ref11.onClick,
      otherProps = _objectWithoutProperties(_ref11, ["className", "iconClassName", "onClick"]);

  return React.createElement("button", _extends({
    className: "btn btn-round\n      ".concat(className || "", "\n      "),
    onClick: onClick
  }, otherProps), React.createElement(SvgQuicklook, {
    className: "icon ".concat(iconClassName || "", " hover-hide")
  }), React.createElement(SvgQuicklookFill, {
    className: "icon ".concat(iconClassName || "", " hover-show")
  }));
};

var SellerLink = function SellerLink(_ref12) {
  var className = _ref12.className,
      sellerMemberId = _ref12.sellerMemberId,
      sellerAlias = _ref12.sellerAlias,
      _ref12$prettifyRating = _ref12.prettifyRating,
      rating = _ref12$prettifyRating.rating,
      includeTotal = _ref12$prettifyRating.includeTotal,
      noRating = _ref12$prettifyRating.noRating,
      isGood = _ref12$prettifyRating.isGood,
      isBad = _ref12$prettifyRating.isBad;
  return React.createElement("span", {
    className: className
  }, React.createElement("a", {
    href: "/profile/feedback/".concat(sellerMemberId, "/").concat(sellerAlias)
  }, sellerAlias), !noRating && React.createElement(Fragment, null, "\xA0", React.createElement(SellerRating, {
    rating: rating,
    includeTotal: includeTotal,
    isGood: isGood,
    isBad: isBad
  })));
};

var SellerRating = function SellerRating(_ref13) {
  var className = _ref13.className,
      rating = _ref13.rating,
      includeTotal = _ref13.includeTotal,
      isGood = _ref13.isGood,
      isBad = _ref13.isBad;
  var formattedRating = rating.toString().replace(",", ".");
  var textClassName = "";

  if (isGood) {
    textClassName = "text-success";
  } else if (isBad) {
    textClassName = "text-danger";
  }

  return React.createElement("span", {
    className: "font-weight-bold ".concat(textClassName, " ").concat(className || "")
  }, Number(formattedRating).toFixed(1) + (includeTotal ? "\xA0/\xA05.0" : ""));
};

var SettingsButton = function SettingsButton(_ref14) {
  var className = _ref14.className,
      iconClassName = _ref14.iconClassName,
      onClick = _ref14.onClick,
      otherProps = _objectWithoutProperties(_ref14, ["className", "iconClassName", "onClick"]);

  return React.createElement("button", _extends({
    className: "btn btn-round\n      ".concat(className || "", "\n      "),
    onClick: onClick
  }, otherProps), React.createElement(SvgSettings, {
    className: "icon ".concat(iconClassName || "")
  }));
};

var ShippingBadge = function ShippingBadge(_ref15) {
  var className = _ref15.className,
      hasFreeShipping = _ref15.hasFreeShipping,
      text = _ref15.text;

  if (hasFreeShipping) {
    return React.createElement("span", {
      className: "badge badge-success badge-inline text-nowrap ".concat(className || "")
    }, text.shipping.freeShipping);
  } else {
    return null;
  }
};

var ShippingLabel = function ShippingLabel(_ref16) {
  var className = _ref16.className,
      hasFreeShipping = _ref16.hasFreeShipping,
      hasNonSpecifiedShipping = _ref16.hasNonSpecifiedShipping,
      isPickupOnly = _ref16.isPickupOnly,
      shippingPrice = _ref16.shippingPrice,
      TagName = _ref16.tagName,
      text = _ref16.text;

  if (hasFreeShipping) {
    return React.createElement(TagName, {
      className: "badge badge-success badge-inline text-nowrap ".concat(className || "")
    }, text.freeShipping);
  } else if (hasNonSpecifiedShipping) {
    return React.createElement(TagName, {
      className: "text-nowrap ".concat(className || "")
    }, text.shipping.nonSpecifiedShipping);
  } else if (isPickupOnly) {
    return React.createElement(TagName, {
      className: "text-nowrap ".concat(className || "")
    }, text.pickup);
  } else if (shippingPrice) {
    return React.createElement(TagName, {
      className: "text-nowrap ".concat(className || "")
    }, text.shipping.addedShippingCost(shippingPrice));
  } else {
    return null;
  }
};

ShippingLabel.defaultProps = {
  tagName: "span"
};

var TimeLeftLabel = function TimeLeftLabel(_ref17) {
  var className = _ref17.className,
      isEndingSoon = _ref17.isEndingSoon,
      timeLeft = _ref17.timeLeft;
  return React.createElement("span", {
    className: "".concat(className || "", " ").concat(isEndingSoon ? "text-danger" : ""),
    dangerouslySetInnerHTML: {
      __html: timeLeft
    },
    "data-item-card-details-time-left": ""
  });
};

var WishlistButton = function WishlistButton(_ref18) {
  var className = _ref18.className,
      iconClassName = _ref18.iconClassName,
      toggled = _ref18.toggled,
      text = _ref18.text,
      onClick = _ref18.onClick,
      otherProps = _objectWithoutProperties(_ref18, ["className", "iconClassName", "toggled", "text", "onClick"]);

  var iconClasses = "icon ".concat(toggled ? "icon-danger" : "", " ").concat(text ? "icon-before" : "", " ").concat(iconClassName || "");
  return React.createElement("button", _extends({
    className: "btn   \n      ".concat(text ? "btn-icon-fixed" : "btn-round", "\n      ").concat(className || "", "\n      "),
    onClick: onClick
  }, otherProps), toggled ? React.createElement(SvgHeartFill, {
    className: iconClasses
  }) : React.createElement(Fragment, null, React.createElement(SvgHeart, {
    className: "".concat(iconClasses, " hover-hide")
  }), React.createElement(SvgHeartFill, {
    className: "".concat(iconClasses, " hover-show")
  })), text && React.createElement("span", {
    className: "ml-2"
  }, text));
};

function ItemCard(props) {
  var animatePriceLabel = props.animatePriceLabel,
      animateTimeLeft = props.animateTimeLeft,
      className = props.className,
      itm = props.itm,
      _props$item = props.item,
      item = _props$item === void 0 ? {} : _props$item,
      language = props.language,
      lazy = props.lazy,
      onAddToWishlist = props.onAddToWishlist,
      onQuickView = props.onQuickView,
      onRemoveFromWishlist = props.onRemoveFromWishlist,
      onSettings = props.onSettings,
      preferredCurrency = props.preferredCurrency,
      ready = props.ready,
      text = props.text;
  var existsInWishList = item.existsInWishList;
  var itemUrl = "".concat(item.url || item.itemUrl).concat(itmToQueryString(itm));
  var imageUrl = item.imageUrl && item.imageUrl.replace("/medium/", "/medium-fit/");

  var handleSettings = function handleSettings(event) {
    event.preventDefault();
    onSettings(item);
  };

  var handleQuickview = function handleQuickview(event) {
    event.preventDefault();
    onQuickView(item.itemId);
  };

  var handleWishlist = function handleWishlist(event) {
    event.preventDefault();

    if (existsInWishList) {
      onRemoveFromWishlist(item.itemId);
    } else {
      onAddToWishlist(item.itemId);
    }
  };

  return React.createElement("div", {
    id: "item-card-".concat(item.itemId),
    "data-item-loaded": ready ? "true" : "false",
    className: "item-card-new\n                ".concat(ready ? "" : "item-card-loading", "\n                ").concat(item.displayHighlighted ? "item-card-new-highlight" : "", "\n                ").concat(className, "\n                ")
  }, React.createElement(ItemCardImage, {
    className: "mb-2 cursor-pointer",
    itemUrl: itemUrl,
    imageUrl: imageUrl,
    lazy: lazy,
    shortDescription: item.shortDescription
  }, React.createElement("div", {
    className: "item-card-badges"
  }, React.createElement(ShippingBadge, {
    className: "mt-2 mr-2",
    hasFreeShipping: item.hasFreeShipping,
    text: text
  }), item.showOnDisplayRibbon && React.createElement(OnDisplayBadge, {
    className: "mt-2 mr-2",
    text: text
  }))), React.createElement("div", {
    className: "item-card-buttons d-flex flex-column"
  }, ready && React.createElement(Fragment, null, React.createElement(WishlistButton, {
    className: "item-card-wishlist-button btn-md-sm ".concat(existsInWishList ? "item-card-wishlist-button-active btn--white" : "btn-translucent", " mb-1"),
    toggled: existsInWishList,
    disabled: !ready,
    onClick: handleWishlist
  }), onQuickView && React.createElement(QuickViewButton, {
    className: "item-card-quickview-button btn btn-md-sm btn-translucent mb-1 d-none d-lg-inline-block",
    onClick: handleQuickview
  }), item.showShopItemSettings && React.createElement(SettingsButton, {
    className: "item-card-settings-button btn btn-md-sm btn-translucent mb-1",
    "data-shop-item-settings-action": true,
    onClick: handleSettings
  }))), React.createElement("p", {
    className: "item-card-title d-flex flex-row mb-2"
  }, item.hasDiscount && React.createElement(DiscountBadge, {
    className: "mr-2 badge-inline",
    discountRate: item.discountRate
  }), React.createElement("a", {
    href: item.url || item.itemUrl,
    id: "item_".concat(item.itemId),
    className: "d-block font-weight-normal text-truncate",
    title: item.shortDescription
  }, item.shortDescription)), React.createElement("div", {
    className: "item-card-details d-flex justify-content-between flex-wrap"
  }, React.createElement("p", {
    className: "mb-0"
  }, item.hasDiscount && React.createElement(DiscountedPriceLabel, {
    className: "text-nowrap mr-2",
    price: item.priceBeforeDiscount
  }), animatePriceLabel ? React.createElement(AnimatedPriceLabel, {
    className: "text-nowrap font-weight-bold item-card-details-price",
    price: item.currentBid || item.price,
    hasDiscount: item.hasDiscount,
    language: language
  }) : React.createElement(PriceLabel, {
    className: "text-nowrap font-weight-bold item-card-details-price",
    price: item.currentBid || item.price,
    hasDiscount: item.hasDiscount,
    language: language
  })), React.createElement("p", {
    className: "text-truncate mb-0 mr-auto"
  }, item.price && React.createElement(MultiCurrency, {
    className: "text-nowrap mr-2",
    amountInSek: item.price,
    preferredCurrency: preferredCurrency,
    language: language
  }), item.price && !item.isShopItem && item.showBids && React.createElement("span", {
    className: "text-gray-400 mr-2"
  }, "|"), !item.isShopItem && item.showBids && React.createElement(BidsLabel, {
    className: "text-nowrap mr-2",
    text: text.numberOfBidsWithCount(item.totalBids)
  })), React.createElement("p", {
    className: "mb-0"
  }, item.isShopItem ? React.createElement(FixedPriceLabel, {
    className: "ml-auto",
    text: text.fixedPrice
  }) : React.createElement(Fragment, null, item.isNewToday && React.createElement(NewTodayLabel, {
    className: "text-truncate mr-2",
    text: text.newToday
  }), animateTimeLeft ? React.createElement(AnimatedTimeLeftLabel, {
    className: "text-gray-600",
    endedComponent: React.createElement("span", {
      className: "text-danger"
    }, text.ended),
    endDate: item.endDate
  }) : React.createElement(TimeLeftLabel, {
    className: "text-truncate",
    isEndingSoon: item.isEndingSoon,
    timeLeft: item.timeLeft
  })))));
}

ItemCard.propTypes = propTypes;
ItemCard.defaultProps = defaultProps;
var itemCard = memo(ItemCard);

function ItemListCard(props) {
  var animateTimeLeft = props.animateTimeLeft,
      className = props.className,
      itm = props.itm,
      _props$item = props.item,
      item = _props$item === void 0 ? {} : _props$item,
      language = props.language,
      lazy = props.lazy,
      onClick = props.onClick,
      onAddToWishlist = props.onAddToWishlist,
      onQuickView = props.onQuickView,
      onRemoveFromWishlist = props.onRemoveFromWishlist,
      onSettings = props.onSettings,
      preferredCurrency = props.preferredCurrency,
      ready = props.ready,
      text = props.text;
  var existsInWishList = item.existsInWishList;
  var itemUrl = "".concat(item.url || item.itemUrl).concat(itmToQueryString(itm));
  var imageUrl = item.imageUrl.replace("/medium/", "/medium-fit/");

  var handleWishlist = function handleWishlist(event) {
    event.preventDefault();
    event.stopPropagation();

    if (existsInWishList) {
      onRemoveFromWishlist(item.itemId);
    } else {
      onAddToWishlist(item.itemId);
    }
  };

  return React.createElement("div", {
    id: "item-card-".concat(item.itemId),
    "data-item-loaded": ready ? "true" : "false",
    className: "item-card-new item-card-list flex-row\n                ".concat(ready ? "" : "item-card-loading", "\n                ").concat(item.displayHighlighted ? "item-card-new-highlight" : "", "\n                ").concat(className)
  }, React.createElement(ItemCardImage, {
    className: "flex-grow-0 flex-shrink-0",
    lazy: lazy,
    itemUrl: itemUrl,
    imageUrl: imageUrl,
    shortDescription: item.shortDescription,
    onClick: onClick
  }), React.createElement("div", {
    className: "mx-2 mx-md-4 py-md-2 d-flex flex-column flex-grow-1 overflow-hidden"
  }, React.createElement("div", {
    className: "d-none d-md-flex d-row align-items-start"
  }, item.hasDiscount && React.createElement(DiscountBadge, {
    className: "mr-2",
    discountRate: item.discountRate
  }), React.createElement("h4", {
    className: "item-card-title mb-0"
  }, React.createElement("a", {
    href: itemUrl,
    id: "item_".concat(item.itemId),
    onClick: onClick,
    title: item.shortDescription
  }, item.shortDescription))), React.createElement("div", {
    className: "d-flex d-md-none d-row align-items-start"
  }, React.createElement("p", null, React.createElement("a", {
    href: itemUrl,
    id: "item_".concat(item.itemId)
  }, item.shortDescription))), React.createElement("div", {
    className: "mb-2 d-none d-md-flex flex-row mt-auto mr-auto"
  }, React.createElement(SellerLink, {
    className: "item-card-list-detail-spaced flex-grow-1 text-truncate mr-2",
    sellerMemberId: item.sellerMemberId,
    sellerAlias: item.sellerAlias,
    prettifyRating: item.prettifyRating
  }), item.isShopItem ? React.createElement(FixedPriceLabel, {
    text: text.fixedPrice
  }) : animateTimeLeft ? React.createElement(AnimatedTimeLeftLabel, {
    className: "",
    endedComponent: React.createElement("span", {
      className: "text-danger"
    }, text.ended),
    endDate: item.endDate
  }) : React.createElement(Fragment, null, item.isNewToday && React.createElement(NewTodayLabel, {
    className: "mr-2",
    text: text.newToday
  }), React.createElement(TimeLeftLabel, {
    isEndingSoon: item.isEndingSoon,
    timeLeft: item.timeLeft
  }))), React.createElement("div", {
    className: "item-card-buttons pb-2 d-flex flex-row flex-grow-0 flex-shrink-0 align-items-center mt-auto"
  }, React.createElement(WishlistButton, {
    className: "btn-outline-dark d-md-none",
    toggled: item.existsInWishList,
    onClick: handleWishlist
  }), React.createElement(WishlistButton, {
    className: "btn-outline-dark d-none d-md-block",
    toggled: item.existsInWishList,
    text: item.existsInWishList ? text.savedToWishlist : text.saveToWishlist,
    onClick: handleWishlist
  }), onQuickView && React.createElement(QuickViewButton, {
    className: "btn-outline-dark ml-2 d-none d-lg-inline-block",
    onClick: function onClick() {
      return onQuickView(item.itemId);
    }
  }), item.showShopItemSettings && React.createElement(SettingsButton, {
    className: "btn-outline-dark ml-2 d-none d-sm-block",
    onClick: function onClick() {
      return onSettings(item.itemId);
    }
  }))), React.createElement("div", {
    className: "item-card-details mx-2 mx-md-4 pl-3 py-md-2 text-right d-flex flex-column flex-grow-0 align-items-end"
  }, React.createElement(PriceLabel, {
    tagName: "h4",
    className: "text-nowrap mb-0 d-none d-md-block",
    price: item.currentBid || item.price,
    hasDiscount: item.hasDiscount,
    language: language
  }), React.createElement(PriceLabel, {
    tagName: "p",
    className: "text-nowrap mb-0 d-block d-md-none",
    price: item.currentBid || item.price,
    hasDiscount: item.hasDiscount,
    language: language
  }), React.createElement(MultiCurrency, {
    className: "mb-0 ml-2",
    amountInSek: item.currentBid || item.price,
    preferredCurrency: preferredCurrency,
    tagName: "p"
  }), item.hasDiscount && React.createElement(DiscountedPriceLabel, {
    className: "mb-0",
    price: item.priceBeforeDiscount,
    tagName: "p"
  }), !item.isShopItem && item.showBids && React.createElement(BidsLabel, {
    className: "mb-0",
    tagName: "p",
    text: text.numberOfBidsWithCount(item.totalBids)
  }), item.showBuyNow && React.createElement(BuyNowLabel, {
    className: "mb-0",
    tagName: "p",
    text: text.buyNow
  }), item.showBuyNow && React.createElement(PriceLabel, {
    className: "text-nowrap font-weight-bold d-none d-md-inline-block",
    price: item.buyNowPrice,
    language: language,
    tagName: "p"
  }), React.createElement(ShippingLabel, {
    className: "mb-0",
    hasFreeShipping: item.hasFreeShipping,
    hasNonSpecifiedShipping: item.hasNonSpecifiedShipping,
    isPickupOnly: item.isPickupOnly,
    shippingPrice: item.shippingPrice,
    tagName: "p",
    text: text
  }), item.showOnDisplayRibbon && React.createElement(OnDisplayBadge, {
    text: text
  }), React.createElement("p", {
    className: "text-truncate mt-auto mb-0 ml-auto d-block d-md-none"
  }, item.isShopItem ? React.createElement(FixedPriceLabel, null) : animateTimeLeft ? React.createElement(AnimatedTimeLeftLabel, {
    className: "",
    endedComponent: React.createElement("span", {
      className: "text-danger"
    }, text.ended),
    endDate: item.endDate
  }) : React.createElement(Fragment, null, item.isNewToday && React.createElement(NewTodayLabel, {
    className: "mr-2",
    text: text.newToday
  }), React.createElement(TimeLeftLabel, {
    isEndingSoon: item.isEndingSoon,
    timeLeft: item.timeLeft
  })))));
}

ItemListCard.propTypes = propTypes;
ItemListCard.defaultProps = defaultProps;
var itemListCard = memo(ItemListCard);

export { itemCard as ItemCard, itemListCard as ItemListCard };
